import { styled } from '@mui/system';

export const TabHeaderContainer = styled('div')({
  minHeight: '54px',
  borderBottom: '2px solid #E1E4E7'
});

export const TabHeader = styled('div')({
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '17px',
  color: '#000000'
});

export const Label = styled('label')({
  fontFamily: 'Roboto-Regular',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '30px',
  letterSpacing: '0.15px',
  color: '#2C3542'
});

export const BalanceSection = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  width: '100%',
  padding: '8px 0px 16px 0',
  height: '20px',
  fontFamily: 'Roboto, sans-serif',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '20px',
  '& label': {
    marginLeft: '8px'
  }
});
